import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AvailableReferenceData, ReferenceContact } from './types';
import { hiringRequestQueries } from 'queryKeys/hiringRequest';
import referencesAPI from 'api/referencesAPI';
import referenceTemplateListAPI from 'api/referenceTemplateListAPI';
import EmailTemplatesAPI from 'api/emailTemplatesAPI';
import { EmailTemplate } from 'components/CandidatesList/MarketplaceProspectQuickView/types';

export const useQueryGetReferenceTemplates = (
  districtId: number,
  options?: Omit<UseQueryOptions<AvailableReferenceData[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<AvailableReferenceData[], AxiosError> => {
  return useQuery({
    queryKey: hiringRequestQueries.hiringRequests.referenceTemplates(districtId).queryKey,
    queryFn: () => referenceTemplateListAPI.fetchReferences().then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useQueryGetReferenceContacts = (
  candidateId: number
): UseQueryResult<ReferenceContact[], AxiosError> => {
  return useQuery({
    queryKey: hiringRequestQueries.hiringRequests.referenceContacts(candidateId).queryKey,
    queryFn: () => referencesAPI.getReferences(candidateId).then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const getEmailTemplatesForReferences = () =>
  EmailTemplatesAPI.getTemplatesForReferences().then((res) => res);

export const useQueryGetEmailTemplatesForReferences = (
  candidateId: number,
  options?: Omit<UseQueryOptions<EmailTemplate[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<EmailTemplate[], AxiosError> => {
  return useQuery({
    queryKey: hiringRequestQueries.hiringRequests.emailTemplates(candidateId).queryKey,
    queryFn: () => getEmailTemplatesForReferences().then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
